module.exports = __webpack_public_path__ + "static/media/dashboard.dbb9c745.svg";